/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.NotificationTemplates {
    "use strict";

    export class NotificationTemplatesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public filter: string;
        public falseValue: boolean;
        disableTemplateChoice: boolean;
        protected additionalCriteria: any;
        public cursorPosition: number;
        private innerDoc: any;
        private smsDoc: any;
        public communicationTypes: any;
        public communicationUserType: any;
        public dataSourceCommType: any;
        public validTags: Array<string> = [];
        public isDocsAndFormsEnabled: boolean = false;
        
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $http: angular.IHttpService,
            protected translate: angular.translate.ITranslateService,
            protected $scope: any,
            protected $timeout: angular.ITimeoutService,
            protected $interval: angular.IIntervalService) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);

            var $this = this;
            //this.itemId = new Guid("");
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.notificationTemplate;
            this.sectionTemplatePath = "app/plugins/notificationTemplates/sectionViews/";

            // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
            let isCo = this.isApplicationModeCO();
            this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_NOTIFICATIONTEMPLATE_TAB_MAIN, true, false, isCo, isCo, isCo);
            this.entityType = 'Template';
            this.falseValue = false;

            if (this.isApplicationModeCO()) {
                this.additionalCriteria = {
                    LevelSetting: null,
                    includeActive: true,
                    coSearchType: null,
                    coBusinessTypeId: null,
                    coFilterByLocationId: null,
                    coSearchResultFilter: 0,
                    location: null,
                    businessType: null,
                    includeSystemLevel: true
                };
            } else {
                this.additionalCriteria = {
                    LevelSetting: 2122,
                    includeActive: true,
                    coSearchType: null,
                    coBusinessTypeId: null,
                    coFilterByLocationId: null,
                    coSearchResultFilter: 0,
                    location: null,
                    businessType: null,
                    includeSystemLevel: true,
                    IncludeCOLevel: true
                };
            }
            $http.get(`/api/Template/Type/List`)
                .then(function (response) {
                    $this.dataSourceCommType = response.data;
                    $this.communicationTypes = _.chain($this.dataSourceCommType).pluck("communicationType").unique().value();
                });
            
            this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.CommunicationTypeUserEnum)
                .then((response: any) => {
                    this.communicationUserType = response;
                });
            
            var $this = this;
            
            function attachEventListeners(): boolean {
                
                var notificationIframe: HTMLIFrameElement, smsIframe: HTMLIFrameElement;
                try {
                    notificationIframe = document.getElementById("notification-wsiwyg-editor").getElementsByTagName("iframe")[0];
                } catch (e) {
                    return false;
                }

                var innerBody: HTMLBodyElement, smsBody: HTMLElement, subjectInput: HTMLInputElement;

                
                $this.innerDoc = notificationIframe.contentDocument || notificationIframe.contentWindow.document;
                innerBody = $this.innerDoc.body;

                if (innerBody.getAttribute('listener') === 'true') return;
                innerBody.setAttribute('listener', 'true');
                innerBody.addEventListener('click', selectRangeInNotification, true);
                innerBody.addEventListener('keyup', selectRangeInNotification, true);
                innerBody.addEventListener('keydown', keyDownEvent, true);
                innerBody.addEventListener('dragover', contentDraggedOver, true);
                //innerBody.addEventListener('input', getBandsFromDocument, true);
                innerBody.addEventListener('drop', contentDroppedOn.bind($this), true);
                innerBody.style.height = "100vh";

                smsBody = document.getElementById("shadow-container-smsmessage");
                smsBody.addEventListener('click', selectRangeInSms, true);
                smsBody.addEventListener('keyup', selectRangeInSms, true);
                smsBody.addEventListener('keydown', keyDownEventForInput, true);
                smsBody.addEventListener('drop', event => {
                    var sel = $this.innerDoc.getSelection();
                    sel.removeAllRanges();
                }, true);


                subjectInput = document.getElementById("shadow-container-emailsubject").getElementsByTagName("input")[0];
                subjectInput.addEventListener('click', selectSubjectInput, true);
                subjectInput.addEventListener('keyup', selectSubjectInput, true);
                subjectInput.addEventListener('keydown', keyDownEventForInput, true);
                subjectInput.addEventListener('drop', event => {
                    var sel = document.getSelection();
                    sel.removeAllRanges();
                }, true);

                    

                var emailTextarea = document.getElementById('wysiwyg-textarea');
                emailTextarea.addEventListener('click', selectEmailTextarea, true);
                emailTextarea.addEventListener('keyup', selectEmailTextarea, true);
                emailTextarea.addEventListener('keydown', keyDownEventForInput, true);
                emailTextarea.addEventListener('drop', event => {
                    var sel = $this.innerDoc.getSelection();
                    sel.removeAllRanges();
                }, true);


                var editorSwitch = document.getElementById("shadow-container-emailbody").getElementsByClassName("toggle")[0];
                editorSwitch.addEventListener('click', function () {
                    $this.$scope.notificationTemplates.context.selectedSection.model["emailBody"] = innerBody.innerHTML;
                });

                return;
            }

            // since we are attaching events to nodes inside of various iframes, they don't load into DOM with the same timing
            // here we will attempt to attach events in an interval, and cancel subsequent attempts when successfull.
            var attachEventInterval = $interval(attachEventListeners, 200);

            // not currently used, but could be useful if requirements change
            function getValidTags(): Array<string> {
                var el: HTMLElement = document.getElementById("notification-tags-accordion");
                var inputs = Array.prototype.slice.call(el.getElementsByTagName("input"), 0);
                var tempStr: string = "";
                inputs.forEach(x => {
                    tempStr += x.alt;
                });
                var tagRegEx = /\{([^}]+)\}/g;
                return tempStr.match(tagRegEx);
            }

            function contentDroppedOn(e: any): any {
                var range = getCursorPosition(e);
                var tag = getPossibleTag(range);
                if (tag !== null) {
                    event.preventDefault();
                } else {
                    var value = e.dataTransfer.getData("text");
                    var doc = e.target["ownerDocument"];
                    var sel = doc.getSelection();
                    setTimeout(() => {
                        sel.deleteFromDocument();
                        sel.removeAllRanges();
    
                        sel.addRange(range);

                        var newNode = doc.createElement("span");
                        newNode.innerHTML = value;
                        
                        this.replaceSelectedText(doc, sel, newNode);
                    }, 1);
                }
            }

            function contentDraggedOver(e: any): any {
                var range = getCursorPosition(e);
                var tag = getPossibleTag(range);
                var allBands = getBandsFromDocument(e.target.ownerDocument);
                var el = document.getElementById("src_copy");
                var forBand = el.getAttribute("data-forband") || "false";
                if (tag !== null || (!checkIfWithinBand(range, allBands) && forBand === "true")) {
                    e.preventDefault();
                    e.dataTransfer.dropEffect = "none";
                } else {
                    e.dataTransfer.dropEffect = "copy";
                }
            }
          
            function keyDownEvent(e : any): any {
                var range = getCursorPosition(e);
                handleKeyDown(e, range);
            }

            function keyDownEventForInput(e: any): any {
                var range = selectTagInInput(e);
                handleKeyDown(e, range);
            }
          
            function handleKeyDown(e, range) {
                var incremented = false;

                if (e.keyCode == 8) { //backspace
                    if (range.startOffset > 0 && range.startOffset === range.endOffset) {
                        //move cursor to evaluate what is about to be backspaced
                        range = decrementStartOffset(range);
                        incremented = true;
                    }

                    var clickedOnTag = getPossibleTag(range);
                    if (clickedOnTag) {
                        //removeSelectionRange(clickedOnTag.range, e.target.ownerDocument);
                        range.deleteContents();
                        e.preventDefault();
                    } else if (incremented) {
                        range = incrementStartOffset(range);
                    }

                } else if (e.keyCode == 46) { //delete
                    var val = e.target.textContent || e.target.value;
                    if (range.startOffset < val.length && range.startOffset === range.endOffset) {
                        range = incrementStartOffset(range);
                        incremented = true;
                    }
                    var clickedOnTag = getPossibleTag(range, true);
                    if (clickedOnTag) {
                        range.deleteContents();
                        e.preventDefault();
                    } else if (incremented) {
                        range = decrementStartOffset(range);
                    }
                }
            }

            function getPreviousTextNode(el) {
                var otherEl = el.previousSibling || el.parentElement.previousSibling;
                if (otherEl.nodeType != Node.TEXT_NODE) {
                    return getPreviousTextNode(otherEl);
                } else {
                    return otherEl;
                }
            }

            function getNextTextNode(el) {
                var otherEl = el.nextSibling || el.parentElement.nextSibling;
                if (otherEl.nodeType != Node.TEXT_NODE) {
                    return getNextTextNode(otherEl);
                } else {
                    return otherEl;
                }
            }

            function incrementStartOffset(range) {
                var isEnd = (range.startOffset === range.startContainer.length) ? true : false;

                if (isEnd) {
                    var el = getNextTextNode(range.endContainer);
                    range.setStart(el, 1);
                    range.setEnd(el, 1);
                } else {
                    range.setStart(range.startContainer || range.offsetNode, range.startOffset + 1);
                    range.setEnd(range.endContainer || range.offsetNode, range.startOffset);
                }
                
                return range;
            }

            function decrementStartOffset(range) {
                if (range.startOffset === 0) {
                    var el = getPreviousTextNode(range.startContainer);
                    range.setStartAfter(el);
                } else {
                    range.setStart(range.startContainer || range.offsetNode, range.startOffset - 1);
                    range.setEnd(range.endContainer || range.offsetNode, range.startOffset);
                }
                return range;
            }

            function selectEmailTextarea(e): any {
                checkForBandInInput(e);
                $this.$scope.inputLastFocused = selectTagInInput(e);
                $this.$scope.inputLastFocused.name = "emailbodytext";
            }

            function selectSubjectInput(e): any {
                checkForBandInInput(e);
                $this.$scope.inputLastFocused = selectTagInInput(e);
                $this.$scope.inputLastFocused.name = "emailsubject";
            }

            function selectRangeInSms(e): void {
                checkForBandInInput(e);
                $this.$scope.inputLastFocused = selectTagInInput(e);
                $this.$scope.inputLastFocused.name = "smsmessage";
            }

            function checkForBandInInput(e) {
                $this.$scope.inputLastFocused.isWithinBand = false;
                var cursorPosition = e.target.selectionStart || 0;
                var matches = e.target.value.match(/({Band(.|\n)*?EndBand})/g);
                if (!matches) return;

                var ndx = -1;
                for (var match of matches) {
                    ndx = e.target.value.indexOf(match, ndx + 1);
                    var openBand = match.match(/{Band.*?\}/);
                    var closeBand = match.match(/{EndBand}/);

                    // check if clicked on open or close tag so we can select entirety
                    if ((cursorPosition > ndx + openBand.index && cursorPosition < ndx + openBand.index + openBand[0].length) ||
                        (cursorPosition > ndx + closeBand.index && cursorPosition < ndx + closeBand.index + closeBand[0].length)) {
                            createSelection(e.target, ndx + openBand.index, ndx + closeBand.index + closeBand[0].length);
                            $this.$scope.inputLastFocused.isWithinBand = false;
                            return;
                    } else if (!$this.$scope.inputLastFocused.isWithinBand) {
                        $this.$scope.inputLastFocused.isWithinBand = cursorPosition > ndx + openBand[0].length - 1
                            && cursorPosition <= ndx + match.length - closeBand[0].length
                    }
                };
            }

            function selectRangeInNotification(e): void {
                var range = getCursorPosition(e);
                var allBands = getBandsFromDocument(e.target.ownerDocument);
                var band = getPossibleBand(range, allBands);

                var clickedOnTag = null;
                if (!band) clickedOnTag = getPossibleTag(range, e.code === 'ArrowRight');
                if (!clickedOnTag && !band) {
                    $this.$scope.inputLastFocused = range;
                } else {
                    
                    if (band) {
                        setSelectionRange(band.range, e.target.ownerDocument);
                        $this.$scope.inputLastFocused = band.range;
                    } else {
                        setSelectionRange(clickedOnTag.range, e.target.ownerDocument);
                        $this.$scope.inputLastFocused = clickedOnTag.range;
                    }
                    
                }

                $this.$scope.inputLastFocused.isWithinBand = band ? false : checkIfWithinBand(range, allBands);
                $this.$scope.inputLastFocused.name = "emailbody";
            }

            function getPossibleBand(range, bands) : any {
                for (var i = 0; i < bands.length; i++) {
                    if ((range.startContainer === bands[i].startNode && range.startOffset > bands[i].range.startOffset && range.startOffset < bands[i].range.startOffset + bands[i].openTag.length)
                        || (range.endContainer === bands[i].endNode && range.endOffset < bands[i].range.endOffset && range.endOffset > bands[i].range.endOffset - bands[i].closeTag.length)) {
                        return bands[i];
                    }
                }
                return null;
            }

            function checkIfWithinBand(range, bands): boolean {
                var thisBand = bands.filter(x => {
                    var overlapsStart = (x.range.intersectsNode(range.startContainer) && range.startOffset > x.range.startOffset)
                    var overlapsEnd = (x.range.intersectsNode(range.endContainer) && range.endOffset < x.range.endOffset)

                    return (overlapsStart || overlapsEnd) &&
                        range.startContainer.nodeType == Node.TEXT_NODE && range.endContainer.nodeType == Node.TEXT_NODE &&
                        range.endOffset !== x.range.endOffset;

                });
                return (thisBand.length > 0) ? true : false;
            }

            this.isDocsAndFormsEnabled = this.securityChecker.hasSecurity(Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_DOCSANDFORMS + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
        }

        initializeSections(): void {
            this.sections.push(new MainSection(0,
                "SECTION_SERVICES_MAIN",
                "main.html",
                true,
                false,
                this.baseEndpoint,
                "",
                this.loggingService,
                this.dataService,
                null, null, null, this.securityKeys.BUSINESSINFO_NOTIFICATIONTEMPLATE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;

            this.businessTypeDetail = model.businessTypeDetail;
        }

        selectSection(item: Meevo.Components.BaseClasses.IDataMaintenanceSection<Model.DataMaintenance>): void {
            if (this.selectedSection && this.selectedSection != item && this.navigationBlocked) {
                this.modalService.alert("MESSAGE_PENDING_CHANGES");
            }
            else {
                if (!this.itemId) {
                    return;
                }

                var prevSection = this.selectedSection;
                if (Model.Guard.isSomething(prevSection)) {
                    prevSection.prevUnselected(); // implement prevUnselected action
                }

                this.selectedSection = item;

                var urlApi = "";
                if (!this.selectedSection.handlesOwnCrud) {
                    this.loadingInProgress = true;
                    var newSectionEndPoint = this.selectedSection.sectionEndpoint;

                    let baseEndpoint = Model.Guard.isSomething(this.selectedSection.baseEndpoint) ? this.selectedSection.baseEndpoint : this.baseEndpoint;
                    if (typeof this.itemId === 'number') {
                        urlApi = `/${this.appSettings.API_ROOT}/${baseEndpoint}/System/${this.itemId}`;
                    }
                    else {
                        urlApi = `/${this.appSettings.API_ROOT}/${baseEndpoint}/${this.itemId}`;
                    }

                    this.dataService.customMethodData(urlApi, "GET", null).then((resp: any) => {
                        if (resp.data.businessTypeDetail != null && resp.data.businessTypeDetail.id == null) {
                            resp.data.businessTypeDetail =
                                {
                                    displayName: "All Business Types",
                                    externalId: "All Business Types",
                                    id: null,
                                    isForAllLocations: false,
                                    locationId: 0,
                                    objectCreationType: 0,
                                    objectState: 2026
                                };
                            resp.data.businessTypeId = null;
                        }

                        this.selectedSection.model = resp.data;

                        this.selectedSection.sectionModelRetrieved();
                        this.selectedSection.activate();

                        if (this.selectedSection.isPrimarySection) {
                            this.updateCoBarData(resp.data);
                            this.initializeHeader(resp.data);
                        }

                    }).finally(() => {
                        this.loadingInProgress = false;
                    });
                }
                this.selectedSection.selected(); // implement selected action

                this.usageTrackingLog(Meevo.Model.VerbEnum.Viewed, null);
            }
        }

        async preview(emailBody) {

            if (this.selectedSection.model["communicationType"] == Model.CommunicationTypeEnum.SelfPay
                || this.selectedSection.model["communicationType"] == Model.CommunicationTypeEnum.SelfPayReminder) {

                var messageTypes = [];
                switch (this.selectedSection.model["communicationType"]) {
                    case Model.CommunicationTypeEnum.SelfPay:
                        messageTypes = [Model.NotificationMessageEnum.SelfPayReceipt];
                        break;
                    case Model.CommunicationTypeEnum.SelfPayReminder:
                        messageTypes = [Model.NotificationMessageEnum.SelfPayReminderReceipt];
                        break;
                }

                if (messageTypes && messageTypes.length > 0) {
                    await this.getTemplateMessages(messageTypes);
                    if (this.selectedSection.model["templateMessages"] && this.selectedSection.model["templateMessages"].length > 0) {
                        for (var i = 0; i < this.selectedSection.model["templateMessages"].length; i++) {
                            emailBody = emailBody + this.selectedSection.model["templateMessages"][i].messageText;
                        }
                    }
                }
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                template: emailBody,
                clickOutsideToClose: true
            }

            this.modalService.showCustom(options);
        }

        getTemplateMessages(messageTypes: Model.NotificationMessageEnum[]): ng.IPromise<any> {
            var request = { "messageTypes": messageTypes };
            return this.dataService.customMethodData("api/Template/Message/List", "POST", request)
                .then((d) => {
                    this.selectedSection.model["templateMessages"] = d.data;
                });
        }

        get showCopy(): boolean {
            return this.verifySelectedSectionModel() &&
                this.selectedSection.isPrimarySection &&
                !this.selectedSection.handlesOwnCrud &&
                this.isReadonly &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge;

        }

        postCopy(): void {
            super.postCopy();
            this.selectedSection.model["isDefault"] = false;
            this.selectedSection.model["displayName"] = "";
        }

        get showDelete(): boolean {
            let temp = <Meevo.Model.Template>this.selectedSection.model;
            return this.showDeleteLogic() && (!temp.isDefault && !temp.isServiceDefault);
        }

        /**
         * Function which determins wether to show the 'Delete' option.
         * this was introduced to allow overriding the show delete logic.
         */
        showDeleteLogic(): boolean {
            return this.verifySelectedSectionModel() &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge &&
                this.selectedSection.isPrimarySection &&
                this.isReadonly &&
                this.isAccessible && this.selectedSection.model.id != null && this.selectedSection.model.id != ""
                && !(this.selectedSection.model.businessTypeId == null && this.selectedSection.model.locationId == undefined && !this.isApplicationModeCO());
        }
        /**
        * Determines whether or not the Maintenance Form should show the top level 'Edit' option.
        * @return {boolean}
        */
        get showEdit(): boolean {
            return this.showEditLogic();
        }

        /**
         * This function is used as the callback function to insert the notification tag
         */
        insertTagInEmailBodyTemplate = (value, context) => {
            if (!this.$scope.inputLastFocused) return;
            var sel: Selection;
            switch (this.$scope.inputLastFocused.name) {
                case "emailbody":
                    var range = this.$scope.inputLastFocused;
                    var thisDoc = range.endContainer.ownerDocument;
                    sel = thisDoc.getSelection();
                    if (sel.rangeCount > 0) {
                        sel.removeAllRanges();
                    }
                    sel.addRange(range);

                    var newNode;
                    if (this.isHtmlInString(value)) {
                        var newNode = thisDoc.createElement("span");
                        newNode.innerHTML = value;
                    } else {
                        newNode = thisDoc.createTextNode(value);
                        
                    }
                    this.replaceSelectedText(thisDoc, sel, newNode);

                    break;
                case "smsmessage":
                    var start = this.$scope.inputLastFocused.selectionStart;
                    var end = this.$scope.inputLastFocused.selectionEnd;
                    const detectReplacement = /<[^>]*>(.*?>)|<[^>]*>/gi;
                    var regExMatch = value.match(detectReplacement);
                    if (regExMatch && regExMatch.length > 0) {
                        value = value.replaceAll(regExMatch[0],"");
                    }
                    var currentBody = context.selectedSection.model.smsMessage || '';
                    context.selectedSection.model.smsMessage = currentBody.substr(0, start) + value + currentBody.substr(end, currentBody.length - end + 1);
                    this.setInputLastFocused(this.$scope.inputLastFocused.startContainer, context.selectedSection.model.smsMessage.indexOf(value) + value.length);
                    break;
                case "emailbodytext":
                    var start = this.$scope.inputLastFocused.selectionStart;
                    var end = this.$scope.inputLastFocused.selectionEnd;
                    var currentBody = context.selectedSection.model.emailBody || '';
                    context.selectedSection.model.emailBody = currentBody.substr(0, start) + value + currentBody.substr(end, currentBody.length - end + 1);
                    this.setInputLastFocused(this.$scope.inputLastFocused.startContainer, context.selectedSection.model.emailBody.indexOf(value) + value.length);
                    break;
                case "emailsubject":
                    var start = this.$scope.inputLastFocused.selectionStart;
                    var end = this.$scope.inputLastFocused.selectionEnd;
                    var currentSubject = context.selectedSection.model.emailSubject || '';
                    context.selectedSection.model.emailSubject = currentSubject.substr(0, start) + value + currentSubject.substr(end, currentSubject.length - end + 1);
                    this.setInputLastFocused(this.$scope.inputLastFocused.startContainer, context.selectedSection.model.emailSubject.indexOf(value) + value.length);
                    break;
                default:
                    return;
            }
        }

        replaceSelectedText(thisDoc, sel, newNode) : void {
            var range;
            if (window.getSelection) {
                if (sel.rangeCount) {
                    range = sel.getRangeAt(0);
                    range.deleteContents();
                    
                    range.insertNode(newNode);
                    range.setStartAfter(newNode);
                    this.$scope.inputLastFocused = range;                    
                }
            } else if (thisDoc.selection && thisDoc.selection.createRange) {
                range = thisDoc.selection.createRange();
                range.text = newNode.innerText;
            }
        }

        
        isHtmlInString(val): boolean {
            var thisRegEx = /<\s*a[^>]*>(.*?)<\s*\/\s*a>|<\s*img.*?src=((?:"|')(.*?)(?:"|'))[^\>]+(>|.*?)/gi;
            return thisRegEx.test(val);
        }

        getOpeningHtmlTag(val): string {
            var thisRegEx = /<[a-zA-Z]+(>|.*?[^?]>)/;
            return val.match(thisRegEx);
        }

        setInputLastFocused(el, ndx): void {
            if (this.$scope.inputLastFocused.setStart) {
                this.$scope.inputLastFocused.setStart(el, ndx);
                this.$scope.inputLastFocused.setEnd(el, ndx);
            } else {
                this.$scope.inputLastFocused.startContainer = el;
                this.$scope.inputLastFocused.endContainer = el;
                this.$scope.inputLastFocused.startOffset = ndx;
                this.$scope.inputLastFocused.endOffset = ndx;
            }
        }


        /**
         * Function which determins wether to show the 'Edit' option.
         * this was introduced to allow overriding the show edit logic.
         */
        showEditLogic(): boolean {
            return this.verifySelectedSectionModel() &&
                !this.selectedSection.handlesOwnCrud &&
                this.isReadonly &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge &&
                this.selectedSection.model.id != null &&
                this.selectedSection.model.id != "" &&
                !(this.selectedSection.model.businessTypeId == null && this.selectedSection.model.locationId == undefined && !this.isApplicationModeCO());
                
        }

        setProperBusinessTypeId(buinessTypeSettings: any): void {
            // fixes the value of the All Buisness Types ID
            if (buinessTypeSettings != null &&
                buinessTypeSettings.id != null &&
                buinessTypeSettings.id == "00000000-0000-0000-0000-000000000001") {
                buinessTypeSettings.id = null;
                this.selectedSection.model.businessTypeId = null;
                this.selectedSection.model["businessTypeDisplayName"] = "All Business Types";
            } else if (buinessTypeSettings != null && buinessTypeSettings.id != null)
                this.selectedSection.model.businessTypeId = buinessTypeSettings.id;
        }

        add(): void {
            this.selectedSection.model = { objectState: Model.ObjectStateEnum.Active };
            this.setMode(Model.MaintenanceFormState.Adding);
            this.postAdd(this.selectedSection.model);
        }

        save(): angular.IPromise<any> {
            let addingMode = this.mode === Meevo.Model.MaintenanceFormState.Adding;

            var contents = null;

            if (this.selectedSection.model["communicationType"] != Meevo.Model.CommunicationTypeEnum.GenericOptInRequested) {
                let wsiwygEditor = $("#notification-wsiwyg-editor");
                if (wsiwygEditor) {
                    let wsiwygIframe = $(wsiwygEditor).find('iframe');
                    if (wsiwygIframe) {
                        let wsiwygContents = wsiwygIframe.contents();
                        if (wsiwygContents) {
                            let wsiwygBody = wsiwygContents.find('body');
                            if (wsiwygBody && wsiwygBody.length && wsiwygBody.length > 0) {
                                contents = wsiwygBody[0].innerHTML;
                            }
                        }
                    }
                }
            }

            if (this.canSave) {

                if (!this.selectedSection.model["isDefault"]) {
                    let msg = "Would you like to assign this template so that it will be used for "
                        + this.translate.instant("ENUM_LABEL_" + this.selectedSection.model["communicationTypeUser"])
                        + " "
                        + this.translate.instant("ENUM_LABEL_" + this.selectedSection.model["communicationType"])
                        + " ?";
                    this.modalService.confirmHandler(msg)
                        .then((confirmResult: boolean) => {                          
                            this.selectedSection.model["isDefault"] = confirmResult ? true : false;
                          
                            if (contents) {
                                this.selectedSection.model["emailBody"] = contents;
                            }

                            this.selectedSection.preSave();
                            this.loadingInProgress = true;

                            //don't use finally on the promises below. this should be skipped if there is a warning
                            //postAdd dismisses the data maint form.
                            let finallyFcn = () => {
                                this.loadingInProgress = false;
                                this.updateCoBarData(this.selectedSection.model);

                                if (this.customDataContextConfig && this.customDataContextConfig.use) {
                                    if (addingMode) {
                                        // if entity didn't have id (wasn't created or copied yet)

                                        this.selectedSection.customControlsModel.answers.map(answer => {
                                            answer.entity_Id = this.selectedSection.model.id;

                                            return answer;
                                        });
                                    }

                                    this.selectedSection.saveCustomControls();
                                }
                            };

                            if (this.mode === Meevo.Model.MaintenanceFormState.Adding || this.mode === Meevo.Model.MaintenanceFormState.Copying) {
                                return this.dataService.add(this.baseEndpoint, this.selectedSection.model, this.itemId, this.selectedSection.sectionEndpoint)
                                    .then((data: any) => {
                                        if (data.isWarning) {
                                            this.handleWarnings(data.responseStatus.errors);
                                        } else {
                                            this.itemId = data.id;
                                            for (let i = 0; i < this.sections.length; i++) {
                                                this.sections[i].setParentItemId(this.itemId);
                                            }
                                            if (data.businessTypeDetail != null && data.businessTypeDetail.id == null) {
                                                data.businessTypeDetail =
                                                    {
                                                        displayName: "All Business Types",
                                                        externalId: "All Business Types",
                                                        id: null,
                                                        isForAllLocations: false,
                                                        locationId: 0,
                                                        objectCreationType: 0,
                                                        objectState: 2026
                                                    };
                                                data.businessTypeId = null;
                                            }
                                            this.selectedSection.model = data;
                                            this.selectedSection.sectionModelRetrieved();
                                            this.setMode(Model.MaintenanceFormState.Readonly);
                                            this.loggingService.trace(`New item saved.`);
                                            this.postAdd(this.selectedSection.model);
                                            finallyFcn();
                                        }
                                    })
                                    .catch((reason: any) => {
                                        this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                                        //finallyFcn();
                                        this.loadingInProgress = false;
                                    });
                                // Handling location override
                            } else {
                                // For overrides pass as location override contract
                                if (this.getTakeOwnershipValue) {
                                    this.selectedSection.model.locationId = this.identityService.current().centralOfficeId;
                                    this.selectedSection.model.homeLocationId = this.identityService.current().centralOfficeId;
                                    this.selectedSection.model.availableToLocations = true;
                                }
                                var updateModel = this.isApplicationModeCO() ? <Model.IHasLocationOverride>this.selectedSection.model : this.selectedSection.model;
                                if (this.allowsCentralOfficeOptions)
                                    this.buildOverrideFieldList();
                                return this.dataService.update(this.baseEndpoint, updateModel, this.itemId, this.selectedSection.sectionEndpoint, this.asLocationId)
                                    .then((data: any) => {
                                        if (data.isWarning) {
                                            this.handleWarnings(data.responseStatus.errors);
                                        } else {
                                            if (data.businessTypeDetail != null && data.businessTypeDetail.id == null) {
                                                data.businessTypeDetail =
                                                    {
                                                        displayName: "All Business Types",
                                                        externalId: "All Business Types",
                                                        id: null,
                                                        isForAllLocations: false,
                                                        locationId: 0,
                                                        objectCreationType: 0,
                                                        objectState: 2026
                                                    };
                                                data.businessTypeId = null;
                                            }

                                            this.selectedSection.model = data;
                                            this.selectedSection.sectionModelRetrieved();
                                            this.setMode(Model.MaintenanceFormState.Readonly);
                                            this.loggingService.trace(`Updates saved.`);
                                            this.postUpdate(this.selectedSection.model);
                                            finallyFcn();
                                        }
                                    })
                                    .catch((reason: any) => {
                                        this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                                        //finallyFcn();
                                        this.loadingInProgress = false;
                                    });
                            }
                        });

                }



                else {
                    this.selectedSection.model["isAlreadyDefault"] = true;
                    if (contents)
                        this.selectedSection.model["emailBody"] = contents;
                    this.selectedSection.preSave();
                    this.loadingInProgress = true;

                    //don't use finally on the promises below. this should be skipped if there is a warning
                    //postAdd dismisses the data maint form.
                    let finallyFcn = () => {
                        this.loadingInProgress = false;
                        this.updateCoBarData(this.selectedSection.model);

                        if (this.customDataContextConfig && this.customDataContextConfig.use) {
                            if (addingMode) {
                                // if entity didn't have id (wasn't created or copied yet)

                                this.selectedSection.customControlsModel.answers.map(answer => {
                                    answer.entity_Id = this.selectedSection.model.id;

                                    return answer;
                                });
                            }

                            this.selectedSection.saveCustomControls();
                        }
                    };

                    if (this.mode === Meevo.Model.MaintenanceFormState.Adding || this.mode === Meevo.Model.MaintenanceFormState.Copying) {
                        return this.dataService.add(this.baseEndpoint, this.selectedSection.model, this.itemId, this.selectedSection.sectionEndpoint)
                            .then((data: any) => {
                                if (data.isWarning) {
                                    this.handleWarnings(data.responseStatus.errors);
                                } else {
                                    this.itemId = data.id;
                                    for (let i = 0; i < this.sections.length; i++) {
                                        this.sections[i].setParentItemId(this.itemId);
                                    }
                                    if (data.businessTypeDetail != null && data.businessTypeDetail.id == null) {
                                        data.businessTypeDetail =
                                            {
                                                displayName: "All Business Types",
                                                externalId: "All Business Types",
                                                id: null,
                                                isForAllLocations: false,
                                                locationId: 0,
                                                objectCreationType: 0,
                                                objectState: 2026
                                            };
                                        data.businessTypeId = null;
                                    }
                                    this.selectedSection.model = data;
                                    this.selectedSection.sectionModelRetrieved();
                                    this.setMode(Model.MaintenanceFormState.Readonly);
                                    this.loggingService.trace(`New item saved.`);
                                    this.postAdd(this.selectedSection.model);
                                    finallyFcn();
                                }
                            })
                            .catch((reason: any) => {
                                this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                                //finallyFcn();
                                this.loadingInProgress = false;
                            });
                        // Handling location override
                    } else {
                        // For overrides pass as location override contract
                        if (this.getTakeOwnershipValue) {
                            this.selectedSection.model.locationId = this.identityService.current().centralOfficeId;
                            this.selectedSection.model.homeLocationId = this.identityService.current().centralOfficeId;
                            this.selectedSection.model.availableToLocations = true;
                        }
                        var updateModel = this.isApplicationModeCO() ? <Model.IHasLocationOverride>this.selectedSection.model : this.selectedSection.model;
                        if (this.allowsCentralOfficeOptions)
                            this.buildOverrideFieldList();
                        return this.dataService.update(this.baseEndpoint, updateModel, this.itemId, this.selectedSection.sectionEndpoint, this.asLocationId)
                            .then((data: any) => {
                                if (data.isWarning) {
                                    this.handleWarnings(data.responseStatus.errors);
                                } else {
                                    if (data.businessTypeDetail != null && data.businessTypeDetail.id == null) {
                                        data.businessTypeDetail =
                                            {
                                                displayName: "All Business Types",
                                                externalId: "All Business Types",
                                                id: null,
                                                isForAllLocations: false,
                                                locationId: 0,
                                                objectCreationType: 0,
                                                objectState: 2026
                                            };
                                        data.businessTypeId = null;
                                    }

                                    this.selectedSection.model = data;
                                    this.selectedSection.sectionModelRetrieved();
                                    this.setMode(Model.MaintenanceFormState.Readonly);
                                    this.loggingService.trace(`Updates saved.`);
                                    this.postUpdate(this.selectedSection.model);
                                    finallyFcn();
                                }
                            })
                            .catch((reason: any) => {
                                this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                                //finallyFcn();
                                this.loadingInProgress = false;
                            });
                    }
                }
            }
        }

        //overrride this method, because, for single location centralOfficeId is undefined, in Notification template homeLocationId is undefined, so I have added !this.isSingleLocation() and I assigned locationId to homelocationId
        get isCoItemInLocation(): boolean {
            this.selectedSection.model.homeLocationId = this.selectedSection.model.locationId;
            return this.verifySelectedSectionModel()
                && !this.isApplicationModeCO()
                && this.selectedSection.model.homeLocationId === this.identityService.current().centralOfficeId
                && !this.isSingleLocation();
        }
    }
}

function removeSelectionRange(range, thisDoc) {
    if (thisDoc.createRange && window.getSelection) {
        var sel = thisDoc.getSelection();
        sel.removeRange(range);
    }
}

function setSelectionRange(range, thisDoc) {
    if (!range) return;
    if (thisDoc.createRange && window.getSelection) {
        var sel = thisDoc.getSelection();
        sel.removeAllRanges();
        sel.addRange(range.cloneRange ? range.cloneRange() : range);
    } else if (thisDoc.selection && thisDoc.body.createTextRange) {
        var textRange = thisDoc.body.createTextRange();
        textRange.moveToElementText(range.offsetNode);
        textRange.collapse(true);
        textRange.moveEnd("character", range.offset);
        textRange.moveStart("character", range.offset);
        textRange.select();
    }
}

function selectTagInInput(event) {
    var el = event.target;
    var selection = createSelection(el, el.selectionStart, el.selectionEnd);

    var begin = findBeginningOfTag(el.value, el.selectionStart);
    if (begin === null || begin < 0) return selection;

    var end = findEndOfTag(el.value, el.selectionStart);
    if (end === null || end >= el.value.length) return selection;

    return createSelection(el, begin, end + 1);
}


function createSelection(field, start, end) {
    if (field.createTextRange) {
        var selRange = field.createTextRange();
        selRange.collapse(true);
        selRange.moveStart('character', start);
        selRange.moveEnd('character', end);
        selRange.select();
    } else if (field.setSelectionRange) {
        field.setSelectionRange(start, end);
    } else if (typeof field.selectionStart != 'undefined') {
        field.selectionStart = start;
        field.selectionEnd = end;
    }
    return field
}

function getCursorPosition(event): any {
    // range is captured differently depending on browser and if we are dealing with input nodes or contenteditable elements
    var thisDoc = event.target && event.target.ownerDocument ? event.target.ownerDocument : document;
    var range;
    var selection;
    // Compatible with most browsers
    if ((event.type === "click" || event.type === "mousedown" || event.type === "mouseup" || event.type === "dragover" || event.type === "drop")
        && typeof thisDoc.caretRangeFromPoint === "function"
        && typeof event.clientX === "number"
        && typeof event.clientY === "number") {
        range = thisDoc.caretRangeFromPoint(event.clientX, event.clientY);
        return range;
    }

    selection = (thisDoc.defaultView || window).getSelection
        ? (thisDoc.defaultView || window).getSelection()
        : thisDoc.getSelection();

    if (selection && selection.rangeCount > 0) {
        range = selection.getRangeAt(0).cloneRange();
        return range;
    }

    return null;
}

function getPossibleTag(range, isKeyUp = false) {
    try {
        if (!range || !range.startContainer || range.startContainer.nodeType !== Node.TEXT_NODE) return null;
        var data = range.startContainer.textContent || range.startContainer.value;

        if (!data || range.startOffset > data.length) return null;

        var begin = findBeginningOfTag(data, range.startOffset, isKeyUp);
        if (begin === null || begin < 0) return null;

        var adjustForEndOfNode = (range.startOffset === data.length) ? 1 : 0;
        var end = this.findEndOfTag(data, range.startOffset - adjustForEndOfNode);
        if (end === null || end >= data.length) return null;

        var word = data.substring(begin, end + 1);
        //if (validTags.filter(x => x === word).length === 0) return;

        if (range.setStart) {
            range.setStart(range.startContainer || range.offsetNode, begin);
            range.setEnd(range.endContainer || range.offsetNode, end + 1);
        } else {
            range.startOffset = begin;
            range.endOffset = end + 1;
        }
        return { word: word, range: range };
    } catch (e) {
        return null;
    }
    
}

function findBeginningOfTag(data, i, isArrowRight = false): number {
    if (!data) return null;
    if (data[i] === "{" && isArrowRight) return i;
    while (i > 0 && data[i - 1] !== "{") {
        if (data[i - 1] == "}") return null
        i--;
    }
    return i - 1;
}

function findEndOfTag(data, i): number {
    if (!data) return null;
    if (data[i] === "}") return i;
    while (i < data.length - 1 && data[i + 1] !== "}") {
        if (data[i + 1] == "{") return null
        i++;
    }
    return i + 1;
}

function isWhitespace(s): boolean {
    return /[ \f\n\r\t\v\u00A0\u2028\u2029]/.test(s);
}

function getElementByText(thisDoc, str, tag = '*') {
    var matches = Array.prototype.slice.call(thisDoc.getElementsByTagName(tag))
        .filter(el => {
            var findText = el.textContent.replace(/\s/g, "");
            return findText.indexOf(str.replace(/\s/g, "")) >= 0
        }
    );
    return matches && matches.length > 0 ? matches[matches.length - 1] : null;
}

function getBandsFromDocument(thisDoc) {
    var val = thisDoc.body.innerText;
    var thisRegEx = /{Band(.|\n)*Band}/g;
    var openRegEx = /{Band.*?\}/g;
    var closeRegEx = /{EndBand}/g;
    var data = [];
    var match: any;

    while ((match = thisRegEx.exec(val)) != null) {
        var thisMatch = match[0];
        var openTag = openRegEx.exec(thisMatch)[0];
        var closeTag = closeRegEx.exec(thisMatch)[0];
        var startNode = getTextNodeFromElement(textNodesUnder(getElementByText(thisDoc, openTag)), openTag);
        var endNode = getTextNodeFromElement(textNodesUnder(getElementByText(thisDoc, closeTag)), closeTag);
        
        var range = new Range();
        range.setStart(startNode, startNode.nodeValue.indexOf(openTag));
        range.setEnd(endNode, endNode.nodeValue.indexOf(closeTag) + closeTag.length);

        data.push({
            name: thisMatch,
            openTag: openTag,
            startNode: startNode,
            closeTag: closeTag,
            endNode: endNode,
            range: range
        });
    }

    return data;
}

function textNodesUnder(node) {
    var all = [];
    for (node = node.firstChild; node; node = node.nextSibling) {
        if (node.nodeType == Node.TEXT_NODE) all.push(node);
        else all = all.concat(textNodesUnder(node));
    }
    return all;
}

function getTextNodeFromElement(nodes, val) {
    for (var i = 0; i < nodes.length; i++) {
        var thisNode = nodes[i];
        if (thisNode.nodeType === Node.TEXT_NODE && thisNode.nodeValue.indexOf(val) >= 0) {
            return thisNode;
        }
    }
}

function htmlEncode(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}